if (!customElements.get('ln-filter-drawer')) {
  customElements.define('ln-filter-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const form = this.querySelector('.ln-facets');
      const trigger = this.querySelector('.ln-filter-trigger');
      if (!form || !trigger || !window.HTMLDialogElement) return;
      this.initialized = true;
      const dialog = document.createElement('dialog');
      dialog.className = 'ln-filter-dialog';
      dialog.setAttribute('aria-label', 'Filter and sort products');
      this.append(dialog);
      dialog.append(form);
      const close = form.querySelector('.ln-filter-close');
      close.hidden = false;
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.addEventListener('click', event => {
        event.preventDefault();
        this.previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
        trigger.setAttribute('aria-expanded', 'true');
        close.focus();
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      });
      this.dialog = dialog;
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.style.overflow = this.previousOverflow || '';
      }
    }
  });
}
